


























































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class EmployeeInfo extends Vue {
  @Prop() profile!: any
  @Prop() companyInfo!: any
  openCollapse: boolean = true

  get benefitUpdatedDate() {
    if (this.profile) {
      return this.profile.point_updated_at
        ? this.moment(this.profile.point_updated_at).format(
            this.$t('common.date_format.mm_dd_hh_mm')
          )
        : ''
    }

    return ''
  }

  get pointFormatted() {
    let unit = this.$t('setting.change_profile.point')
    if (
      this.profile &&
      this.profile.point != null &&
      this.profile.point !== ''
    ) {
      return `${this.profile.point.toLocaleString('en-US')}${unit}`
    }

    return `-${unit}`
  }
}
